import { SettingsApiService } from '@api/settings/settings.api';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AssetConnectionSetting, AssetSettings } from '../../types/Setting';
import { ActionResponse, CheckAssetConnectionResponse } from '../../types/DataResult';

@Injectable()
export class SettingsRepositoryService {
  public constructor(private readonly settingsApi: SettingsApiService) {}

  public getSettingsAssetConnections(): Observable<AssetSettings> {
    return this.settingsApi.getSettingsAssetConnections();
  }

  public deleteSettingsAssetConnection(id: string): Observable<ActionResponse> {
    return this.settingsApi.deleteSettingsAssetConnection(id);
  }

  public checkAssetConnection(id: string): Observable<CheckAssetConnectionResponse> {
    return this.settingsApi.checkAssetConnection(id);
  }

  public createSettingsAssetConnection(connection: AssetConnectionSetting): Observable<ActionResponse> {
    return this.settingsApi.createSettingsAssetConnection(connection);
  }

  public updateSettingsAssetConnection(connection: AssetConnectionSetting): Observable<ActionResponse> {
    return this.settingsApi.updateSettingsAssetConnection(connection);
  }
}
